/**
 * sparePartsApi.js - the Spare Parts tab's calls to the server
 * (server/routes/spareParts.js, /api/spare-parts). Each answers
 * { ok, status, body } and never throws; body.error says what went wrong.
 */
import { json, send, qs } from '../../utils/api';

export { errorOf } from '../../utils/api';

const BASE = '/api/spare-parts';

const enc = encodeURIComponent;

// catalog
export const listParts = (params) => json(`${BASE}/parts${qs(params)}`);
export const getPart = (key) => json(`${BASE}/parts/${enc(key)}`);
export const createPart = (part) => json(`${BASE}/parts`, send('POST', part));
export const updatePart = (id, patch) => json(`${BASE}/parts/${enc(id)}`, send('PUT', patch));
export const checkPrice = (id, body) => json(`${BASE}/parts/${enc(id)}/price-check`, send('POST', body));
export const deletePart = (id) => json(`${BASE}/parts/${enc(id)}`, { method: 'DELETE' });

// robots
export const listRobots = (params) => json(`${BASE}/robots${qs(params)}`);
export const getRobot = (id) => json(`${BASE}/robots/${enc(id)}`);
export const createRobot = (robot) => json(`${BASE}/robots`, send('POST', robot));
export const updateRobot = (id, patch) => json(`${BASE}/robots/${enc(id)}`, send('PUT', patch));
export const deleteRobot = (id) => json(`${BASE}/robots/${enc(id)}`, { method: 'DELETE' });
export const addRobotPart = (id, line) => json(`${BASE}/robots/${enc(id)}/parts`, send('POST', line));
export const updateRobotPart = (id, lineId, patch) => json(`${BASE}/robots/${enc(id)}/parts/${enc(lineId)}`, send('PUT', patch));
export const removeRobotPart = (id, lineId) => json(`${BASE}/robots/${enc(id)}/parts/${enc(lineId)}`, { method: 'DELETE' });

// stock
export const listInventory = (params) => json(`${BASE}/inventory${qs(params)}`);
export const createStock = (row) => json(`${BASE}/inventory`, send('POST', row));
export const updateStock = (id, patch) => json(`${BASE}/inventory/${enc(id)}`, send('PUT', patch));
export const deleteStock = (id) => json(`${BASE}/inventory/${enc(id)}`, { method: 'DELETE' });
export const moveStock = (id, move) => json(`${BASE}/inventory/${enc(id)}/moves`, send('POST', move));

// bulk
export const importRows = (payload) => json(`${BASE}/import`, send('POST', payload));
